import * as Utils from '../modules/utilities';

const accordion = document.querySelector('.accordion');
const accordionItems = document.querySelectorAll('.accordion__container');
const accordionContentPanes = document.querySelectorAll('.accordion__body');
    
for (let i = 0; i < accordionItems.length; i++) {
    const accordionHeading = accordionItems[i].querySelector('.accordion__title');
    accordionHeading.addEventListener('click', accordionControls);  
}

function accordionControls(event)
{
    for (let i = 0; i < accordionContentPanes.length; i++) {
        
        const target = event.target.parentNode.getAttribute('aria-controls');
        const panelID = accordionContentPanes[i].id;
        
        if (panelID === target) {
            Utils.toggleElement(accordionContentPanes[i]); 
        }
    	
    }
};

export default accordionControls;
